import React, { Component } from "react";
import { Modal, DatePicker } from "antd";
import moment from "moment";

import { apiJourney } from "../../../../api/api-journey";
import { emitter } from "../../../../common/utils/emitter";
import { alert } from "../../../../common/utils/alert";

export class LockingEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      lockTime: null,
    };
    //this.branchs = [];
  }

  async componentDidMount() {}

  handleLockTime = (date, dateString) => {
    if (date) {
      this.setState({
        errorMessage: "",
        lockTime: date.startOf("month").valueOf(),
      });
    } else {
      this.setState({
        errorMessage: "",
        lockTime: 0,
      });
    }
  };

  submitLock = () => {
    const { lockTime, errorMessage } = this.state;
    if (!lockTime) {
      if (!errorMessage) {
        this.setState({
          errorMessage: "Vui lòng chọn thời gian lọc!",
        });
      }
    } else {
      this.confirmLock(true, lockTime);
    }
  };

  confirmLock = (isAccept, lockTime) => {
    let title = "Khóa chỉnh sửa";
    let content = `Bạn có chắc chắn muốn khóa chỉnh sửa NKHT hay không?
            Mọi NKHT từ tháng ${moment(lockTime).format(
              "M"
            )} trở vể trước đó sẽ không được phép chỉnh sửa.`;
    Modal.confirm({
      title: title,
      icon: null,
      content: content,
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      onOk: () => {
        if (isAccept) {
          try {
            emitter.emit("FETCH_LOADING", true);
            apiJourney.lockingEdit({ lock_time: lockTime }).then((res) => {
              if (res.status === "success") {
                alert("success", "Khóa chỉnh sửa thành công");
                this.props.updateLockTime(res.data.lock_time);
                emitter.emit("FETCH_LOADING", false);
              } else {
                alert("error", "Không khóa chỉnh sửa thành công");
                emitter.emit("FETCH_LOADING", false);
              }
            });
          } catch (error) {
            alert("error", "Không khóa chỉnh sửa thành công");
            emitter.emit("FETCH_LOADING", false);
          }
        }
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  render() {
    const { errorMessage, lockTime } = this.state;
    return (
      <div className="locking">
        <div className="locking-edit">
          <div>Khóa chỉnh sửa NKHT từ:</div>
          <DatePicker
            // inputReadOnly
            picker="month"
            className="month-picker"
            dropdownClassName="date-picker-dropdown-bottom"
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            value={lockTime ? moment(lockTime) : null}
            disabledDate={(currentDate) => {
              const currentTimes = currentDate.valueOf();
              const nowTimes = moment()
                .endOf("month")
                .subtract(1, "months")
                .valueOf();
              return currentTimes > nowTimes;
            }}
            onChange={this.handleLockTime}
            format="MM/YYYY"
          />
          <div className="error-message-mobile">{errorMessage}</div>
          <div onClick={this.submitLock} className="lock-btn">
            Khóa chỉnh sửa
          </div>
        </div>
        <div>
          <div className="error-message">{errorMessage}</div>
        </div>
      </div>
    );
  }
}
